export default "__VITE_ASSET__BFbzPxuC__"